export type Token = {
  label: string
  value: string
  description?: string
}

export const ProposalLinkToken = 'proposal_link'

export const Tokens: Token[] = [
  { label: 'Company Name', value: 'company_name' },
  { label: 'Customer Display Name', value: 'customer_displayname' },
  { label: 'Customer Greeting', value: 'customer_greeting', description: 'Hello Fred' },
  { label: 'Project Number', value: 'project_no' },
  { label: 'Sales Person Name', value: 'salesperson_name' },
  { label: 'Sales Person Email', value: 'salesperson_email' },
  { label: 'Proposal Link', value: ProposalLinkToken },
]

export const PaymentLinkToken = 'payment_link'

export const InvoiceReminderTokens: Token[] = [
  { label: 'Customer Name', value: 'customer_name' },
  { label: 'Company Name', value: 'company_name' },
  { label: 'Invoice Number', value: 'invoice_number' },
  { label: 'Invoice Total', value: 'invoice_total' },
  { label: 'Balance Due', value: 'balance_due' },
  { label: 'Due Date', value: 'due_date' },
  { label: 'Days Overdue', value: 'days_overdue' },
  { label: 'Payment Link', value: PaymentLinkToken },
]

export const convertFromHandlebars = (text: string | undefined, tokens: Token[]): string => {
  if (!text) {
    return ''
  }
  const handlebarPattern = /\{\{(.*?)\}\}/g
  let replacedText = text
  for (const match of text.matchAll(handlebarPattern)) {
    const token = tokens.find(t => t.value === match[1])
    if (token) {
      replacedText = replacedText.replace(`{{${token.value}}}`, `<code data-value="${token.value}">${token.label}</code>`)
    }
  }
  return convertRepeatedSpaces(replacedText)
}

export const convertToHandlebars = (text: string | undefined, singleLine: boolean): string => {
  if (!text) {
    return ''
  }
  const parser = new DOMParser()
  const doc = parser.parseFromString(text, 'text/html')
  for (const codeTag of [...doc.getElementsByTagName('code')]) {
    codeTag.replaceWith(`{{${codeTag.getAttribute('data-value')}}}`)
  }

  if (singleLine) {
    // remove the wrapping <p></p>
    return convertRepeatedSpaces(doc.getElementsByTagName('body')[0].children[0].innerHTML)
  }
  return convertRepeatedSpaces(doc.getElementsByTagName('body')[0].innerHTML)
}

const repeatedSpacePattern = /[ ]{1}([ ]{1,})/g

const convertRepeatedSpaces = (text?: string): string => {
  return text?.replaceAll(repeatedSpacePattern, (_, group1) => {
    return ' ' + new Array(group1.length).fill('&nbsp;').join('')
  }) || ''
}